<template>
  <div class="columns">
    <SearchMusEdLinks class="column is-one-quarter container" />
    <div
      class="column is-three-quarters museum-container"
      v-bind:class="{ columns: results.searched }"
    >
      <div v-bind:class="{ column: results.searched }">
        <h1>Search Lesson Plans</h1>
        <SearchMusEdForm
          class="form"
          :filters="filters"
          :filterTerms="filterTerms"
          :searching="results.searched"
          :term="results.term"
          :page="this.results.currentPage"
          v-on:update:cleartags="clearTags"
          v-on:update:cleartag="clearTag($event)"
          v-on:update:searching="search($event)"
        />
        <SearchPagination
          class="pagination"
          v-if="results.searched"
          :sizeValue="this.results.sizeValue"
          :fromValue="this.results.fromValue"
          :currentPage="this.results.currentPage"
          :totalPages="this.results.totalPages"
          v-on:update:next="nextClicked"
          v-on:update:prev="prevClicked"
        />
        <SearchMusEdResults
          v-if="results.searched"
          class="column"
          :results="results"
          :filterTerms="filterTerms"
          v-on:mounted:results="checkRoute"
        />
        <SearchPagination
          class="pagination"
          v-if="results.searched"
          :sizeValue="this.results.sizeValue"
          :fromValue="this.results.fromValue"
          :currentPage="this.results.currentPage"
          :totalPages="this.results.totalPages"
          v-on:update:next="nextClicked"
          v-on:update:prev="prevClicked"
        />
      </div>
      <div
        v-bind:class="{
          column: results.searched,
          'is-one-third': results.searched
        }"
      >
        <SearchMusEdFilters
          :filters="filters"
          :filterTerms="filterTerms"
          :searched="results.searched"
        />
        <SearchQueryArtCollection
          v-if="results.term && results.term.length > 0"
          :term="results.term"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SearchMusEdLinks from "@/components/SearchMusEdLinks";
import SearchMusEdForm from "@/components/SearchMusEdForm";
import SearchMusEdFilters from "@/components/SearchMusEdFilters";
import SearchMusEdResults from "@/components/SearchMusEdResults";
import SearchQueryArtCollection from "@/components/SearchQueryArtCollection";
import SearchPagination from "@/components/SearchPagination";
import museumFilters from "@/assets/museumfilters.json";

export default {
  name: "SearchMusEd",
  data() {
    return {
      results: {
        term: "",
        searched: false,
        sizeValue: 10,
        fromValue: 0,
        totalPages: 1,
        results: {},
        suggestions: {},
        totals: 0,
        currentPage: 1,
        endPage: 1
      },
      filters: {
        gradeChecked: [],
        subjectChecked: [],
        typeChecked: [],
        locationChecked: []
      },
      filterTerms: museumFilters,
      path: "",
      tempArray: [],
      tempFilter: ""
    };
  },
  components: {
    SearchMusEdLinks,
    SearchMusEdForm,
    SearchMusEdFilters,
    SearchMusEdResults,
    SearchQueryArtCollection,
    SearchPagination
  },
  mounted() {
    this.checkResultsPage();
  },
  methods: {
    search(value) {
      this.results.term = value.term;
      this.results.searched = value.searched;
      this.results.results = value.results;
      this.results.totals = value.totals.value;
      if (this.results.totals == undefined) {
        this.results.totals = value.totals;
      }
      this.results.totalPages = value.totalPages;
      this.results.suggestions = value.suggestions;
      this.results.startResults = value.startResults;
      this.results.fromValue = value.fromValue;
      this.results.sizeValue = value.sizeValue;
      this.results.endPage = value.endPage;
      this.setResultsPath();
    },
    setResultsPath() {
      this.tempArray = this.filters.gradeChecked.concat(
        this.filters.locationChecked,
        this.filters.subjectChecked,
        this.filters.typeChecked
      );
      this.tempFilter = this.tempArray.join(",");
      this.$router.push({
        name: "museumedresults",
        query: {
          qt: this.results.term,
          md: this.tempFilter,
          pg: this.results.currentPage
        }
      });
    },
    clearTag(id) {
      if (this.filters.gradeChecked.includes(id)) {
        this.filters.gradeChecked.splice(
          this.filters.gradeChecked.indexOf(id),
          1
        );
      }
      if (this.filters.subjectChecked.includes(id)) {
        this.filters.subjectChecked.splice(
          this.filters.subjectChecked.indexOf(id),
          1
        );
      }
      if (this.filters.typeChecked.includes(id)) {
        this.filters.typeChecked.splice(
          this.filters.typeChecked.indexOf(id),
          1
        );
      }
      if (this.filters.locationChecked.includes(id)) {
        this.filters.locationChecked.splice(
          this.filters.locationChecked.indexOf(id),
          1
        );
      }
    },
    clearTags() {
      this.filters = {
        gradeChecked: [],
        subjectChecked: [],
        typeChecked: [],
        locationChecked: []
      };
    },
    checkResultsPage() {
      this.path = this.$route.fullPath;
      if (this.path.includes("results")) {
        this.results.searched = true;
        this.results.term = this.$route.query.qt;
      }
    },
    setTempFilter() {
      if (this.$route.query.md) {
        if (this.$route.query.md.length === 0) {
          this.tempFilter = [];
        } else {
          this.tempFilter = this.$route.query.md.split(",");
        }
      }
    },
    checkRoute() {
      this.setTempFilter();
      for (let i = 0; i < this.filterTerms.grade.length; i++) {
        let childArray = this.filterTerms.grade[i].id;
        if (this.tempFilter.includes(childArray)) {
          this.filters.gradeChecked.push(childArray);
        }
      }
      for (let i = 0; i < this.filterTerms.subject.length; i++) {
        let childArray = this.filterTerms.subject[i].id;
        if (this.tempFilter.includes(childArray)) {
          this.filters.subjectChecked.push(childArray);
        }
      }
      for (let i = 0; i < this.filterTerms.type.length; i++) {
        let childArray = this.filterTerms.type[i].id;
        if (this.tempFilter.includes(childArray)) {
          this.filters.typeChecked.push(childArray);
        }
      }
      for (let i = 0; i < this.filterTerms.location.length; i++) {
        let childArray = this.filterTerms.location[i].id;
        if (this.tempFilter.includes(childArray)) {
          this.filters.locationChecked.push(childArray);
        }
      }
      this.setResultsPath();
    },
    nextClicked() {
      this.$emit("update:next");
      this.results.currentPage++;
    },
    prevClicked() {
      this.$emit("update:prev");
      this.results.currentPage--;
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: $size-5;
  margin-top: -1.5em;
}
.form {
  height: inherit;
  margin-bottom: 1em;
}
.pagination {
  display: flex;
  justify-content: flex-end;
}
@media screen and (max-width: $tablet) {
  .museum-container {
    flex-direction: column-reverse;
    display: flex;
  }
}
</style>
